var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
import { isErr } from "healthex-common/result";
import { NOT_LOADED } from "../Infra/RemoteData";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("common");
export class ResetPasswordViewModel {
    constructor(container) {
        this.input = { password: "", reEnteredPassword: "" };
        this.newPasswordSaved = false;
        this.error = null;
        this.resetPasswordUIManager = container.resetPasswordUIManager;
        this.authManager = container.authManager;
        this.routingUIManager = container.routingUIManager;
        this.passwordValidator = container.passwordValidator;
    }
    get user() {
        return this.resetPasswordUIManager.authenticatedUser;
    }
    updateInput(update) {
        this.error = null;
        this.input = { ...this.input, ...update };
    }
    get userEmail() {
        if (this.user === NOT_LOADED)
            return null;
        if (this.user && this.user.type !== "PATIENT" && this.user.type !== "SCREENSHOT_USER") {
            return this.user.email;
        }
        return null;
    }
    get organization() {
        return this.resetPasswordUIManager.organization;
    }
    get organizationPasswordConfiguration() {
        var _a;
        if (this.organization === NOT_LOADED)
            return null;
        return (_a = this.organization) === null || _a === void 0 ? void 0 : _a.passwordConfiguration;
    }
    async updatePassword() {
        const validationResult = this.passwordValidator.validate(this.input.password, this.input.reEnteredPassword, null, null, null, this.organizationPasswordConfiguration);
        if (isErr(validationResult)) {
            this.error = this.getValidationErrorMessage(validationResult.error);
            return;
        }
        if (this.resetPasswordUIManager.resetPasswordToken) {
            await this.authManager.resetPassword(this.input.password, this.resetPasswordUIManager.resetPasswordToken);
            this.newPasswordSaved = true;
        }
    }
    async navigateToLoginPage() {
        this.routingUIManager.navigateTo(NamedRoutes.LOGIN_AS_ORG_USER);
    }
    getValidationErrorMessage(validationError) {
        switch (validationError) {
            case "OLD_PASSWORD_REUSED":
                return t("Old password cannot be reused. Please use a new password");
            case "PASSWORD_MISMATCH":
                return t("Passwords don't match! Please try again.");
            case "PASSWORD_CRITERIA_MISMATCH":
                return t("Password doesn't meet the requirements! Please try again.");
            case "SSO_ENABLED":
                return t("Password cannot be changed when SSO is enabled.");
            default:
                return t("An unexpected error occurred");
        }
    }
}
__decorate([
    observable
], ResetPasswordViewModel.prototype, "input", void 0);
__decorate([
    observable
], ResetPasswordViewModel.prototype, "newPasswordSaved", void 0);
__decorate([
    observable
], ResetPasswordViewModel.prototype, "error", void 0);
__decorate([
    computed
], ResetPasswordViewModel.prototype, "user", null);
__decorate([
    computed
], ResetPasswordViewModel.prototype, "userEmail", null);
__decorate([
    computed
], ResetPasswordViewModel.prototype, "organization", null);
__decorate([
    computed
], ResetPasswordViewModel.prototype, "organizationPasswordConfiguration", null);
